import { State } from '..';

interface EventProps {}

interface Config<S, P, A, R> {
  states: Array<State<S, P, A, R>>;
  attributes?: Partial<A>;
}

const StateGroup = function <S, P extends EventProps, A extends { hint: string }, R>({
  states,
  attributes,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      for (let i = 0; i < states.length; i++) {
        const state = states[i];
        const result = await state.onEnter?.(args);
        if (result) return result;
      }
    },
    onAction: async (args) => {
      for (let i = 0; i < states.length; i++) {
        const state = states[i];
        const result = await state.onAction?.(args);
        if (result) return result;
      }
    },
    attributes: attributes as any,
  };
};

export default StateGroup;
